export default __webpack_public_path__ + "img/59.25fe2ca.svg";